import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from "axios";
import "../vendor-details/VendorDetails.css"
import { useParams } from 'react-router-dom';
import useEmirateFromCoordinates, { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common.js";
// import Slider from "react-slick";
import Hls from "hls.js";

//Navbar and Left Section Images
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
// import plusicon from '../../assets/home-images/plusicon.png';
// import profileicon from '../../assets/home-images/profileicon.png';
// import search from '../../assets/home-images/search.png';
// import videos from '../../assets/home-images/videos.png';
// import blogs from '../../assets/home-images/blogs.png';
import save from '../../assets/home-images/save.png';
// import menu from '../../assets/home-images/menu.png';
// import downarrow from '../../assets/home-images/downarrow.png';
// import flagicon from '../../assets/home-images/flagicon.png';

import omanflag from '../../assets/experience/omanflag.png';
import qatarflag from '../../assets/experience/qatarflag.png';
import kuwaitflag from '../../assets/experience/kuwaitflag.png';
import ksaflag from '../../assets/experience/ksaflag.png';
import xmark from '../../assets/home-images/right-section-images/xmark.png';
// import upload from '../../assets/offers/upload.png';
import leftarrow from '../../assets/offers/leftarrow.png';
import star from '../../assets/experience/star.png';
import downarrowicon from '../../assets/categorylist/downarrowicon.png';
import nodata from '../../assets/experience/nodata.png';
import nopost from "../../assets/vendordetails/nopost.png";
// import noevents from "../../assets/vendordetails/noevents.png";
import email from "../../assets/vendordetails/email.png";
import phone from "../../assets/vendordetails/phone.png";
import whatsapp from "../../assets/vendordetails/whatsapp.png";
import www from "../../assets/vendordetails/www.png";
import threedot from '../../assets/home-images/mid-section-images/threedot.png';
import videomute from "../../assets/home-images/mid-section-images/videomute.png";
import videounmute from "../../assets/home-images/mid-section-images/videounmute.png";
import popup_yatch from "../../assets/offers/popup_yatch.png";
import hearticon from '../../assets/home-images/mid-section-images/hearticon.png';
import commenticon from '../../assets/home-images/mid-section-images/commenticon.png';
import shareicon from '../../assets/home-images/mid-section-images/shareicon.png';

import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import { FeedMediaContent } from "../home/FeedMediaContent .js";
import LeftSection from "../common-component/left-menu-section/LeftSection.js";
import Navbar from "../common-component/navbar/Navbar.js";

const countryicons = [omanflag, qatarflag, kuwaitflag, ksaflag]
const VendorDetails = () => {
    const { user_id } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    // const [countrypopup, setCountrypopup] = useState(false);
    const [states, setStates] = useState([]);
    const [vendordetails, setVendordetails] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    // const [activeTab, setActiveTab] = useState(location.state?.activeTab || "Posts");
    const [activeSubTab, setActiveSubTab] = useState("All");
    const [vendorpostlist, setVendorpostlist] = useState([]);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);
    const [globalMute, setGlobalMute] = useState(true);
    // const videoRefs = useRef({});
    const [workinghours, setWorkinghours] = useState([]);
    const [longitude, setLongitude] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [vendorcouponlist, setVendorcouponlist] = useState([]);
    const [vendoreventlist, setVendoreventlist] = useState([]);
    const [workinghoursEnabled, setWorkinghoursEnabled] = useState(0);
    const [expand, setExpand] = useState(false);
    const [loading, setLoading] = useState(true);
    const [outletsPopupOpen, setOutletsPopupOpen] = useState(false);

    // Initialize with location state if available
    const [activeTab, setActiveTab] = useState(
        searchParams.get('tab') || "Posts"
    );

    useEffect(() => {
        const tabParam = searchParams.get('tab');
        if (tabParam) {
            setActiveTab(tabParam);
        }
    }, [searchParams]);
    useEffect(() => {
        // Set default location immediately to avoid waiting for geolocation
        setLatitude(24.4539);
        setLongitude(54.3773);

        // Try to get user's actual location (non-blocking)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    // Keep default values already set above
                },
                {
                    timeout: 5000, // 5 second timeout
                    enableHighAccuracy: false // Faster response
                }
            );
        }
    }, []);

    // Step 2: Call API - coordinates are set immediately with defaults
    useEffect(() => {
        if (!loading) {
            fetchVendorCouponList(latitude || 24.4539, longitude || 54.3773);
        }
    }, [latitude, longitude, loading]);

    // Fetch events when Events tab is active
    useEffect(() => {
        if (activeTab === "Events" && user_id && !loading) {
            fetchVendorEventList();
        }
    }, [activeTab, user_id, loading]);
    // Add this useEffect to handle tab changes when navigating from other pages
    // Handle navigation state changes


    const emirate = useEmirateFromCoordinates(latitude, longitude);

    // const [followingStates, setFollowingStates] = useState(
    //     new Array(vendordetails.length).fill(false)
    // );

    const dayOrder = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // Add this mapping object
    const dayNameMap = {
        "Sun": "Sunday",
        "Mon": "Monday",
        "Tue": "Tuesday",
        "Wed": "Wednesday",
        "Thu": "Thursday",
        "Fri": "Friday",
        "Sat": "Saturday"
    };

    const [open, setOpen] = useState(false);
    const todayName = dayOrder[new Date().getDay()];
    const todayIndex = dayOrder.indexOf(todayName);
    const todayData = workinghours?.find(d => d.day === todayName);

    const formatTimeSlots = (slots) => {
        if (!slots || slots.length === 0) return "Closed";
        return slots.map(s => `${s.start_time} - ${s.end_time}`).join(", ");
    };

    // Reorder the week to start from today
    const orderedWorkingHours = (workinghours || [])
        .filter(d => d.day !== todayName)
        .sort((a, b) => {
            const aIndex = (dayOrder.indexOf(a.day) - todayIndex + 7) % 7;
            const bIndex = (dayOrder.indexOf(b.day) - todayIndex + 7) % 7;
            return aIndex - bIndex;
        });

    // const handleToggle = (index) => {
    //     const updated = [...followingStates];
    //     updated[index] = !updated[index];
    //     setFollowingStates(updated);
    // };

    // ✅ FIXED: Simplified data filtering logic
    const getFilteredData = () => {
        if (activeTab === "Posts") {
            if (activeSubTab === "All") {
                return vendorpostlist; // Show all posts (images + videos)
            }
            if (activeSubTab === "Images") {
                return vendorpostlist.filter(
                    (post) => post.post_images?.length > 0 && !post.video_file
                );
            }
            if (activeSubTab === "Videos") {
                return vendorpostlist.filter(
                    (post) => post.video_file && post.video_file !== ""
                );
            }
        }

        if (activeTab === "Offers") return []; // Add offers data when available
        if (activeTab === "Events") return []; // Add events data when available

        return [];
    };

    const filteredData = getFilteredData();

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => setActiveSlide(next),
    };

    const initializeVideo = (el, videoUrl, videoIndex) => {
        if (!el || !videoUrl || el.dataset.hlsInitialized) return;

        // Dynamically construct the proxy URL based on environment
        const backendBase = BACKEND_URL.replace('/api/', ''); // Get base URL without /api/

        // Extract just the filename from the video URL
        const filename = videoUrl.split('/').pop();

        // Construct the proxy URL dynamically
        const proxyUrl = `${backendBase}/video/${filename}`;

        console.log('Loading video from:', proxyUrl); // Debug log

        const playMutedVideo = () => {
            el.muted = true;
            el.volume = 0;
            el.play().catch(err => console.log('Autoplay prevented:', err));
        };

        // ... rest of your HLS code stays the same
        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: false,
                enableWorker: true,
                lowLatencyMode: false,
                backBufferLength: 90,
                maxBufferLength: 30,
                maxMaxBufferLength: 60,
                maxBufferSize: 60 * 1000 * 1000,

                startLevel: 0,
                autoStartLoad: true,
                progressive: true,
                xhrSetup: function (xhr) {
                    xhr.withCredentials = false;
                    xhr.timeout = 10000;
                }
            });

            hls.loadSource(proxyUrl);
            hls.attachMedia(el);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                playMutedVideo();
            });

            hls.on(Hls.Events.ERROR, (event, data) => {
                console.error('HLS Error:', data); // Add error logging
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                }
            });

            el.dataset.hlsInitialized = 'true';
            el.hlsInstance = hls;

        } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
            el.src = proxyUrl;
            playMutedVideo();
            el.dataset.hlsInitialized = 'true';
        }

        el.dataset.videoIndex = videoIndex;
    };
    const toggleMute = () => {
        const newMuteState = !globalMute;
        setGlobalMute(newMuteState);

        // Apply to all videos
        document.querySelectorAll('video[data-video-index]').forEach(videoElement => {
            videoElement.muted = newMuteState;
            videoElement.volume = newMuteState ? 0 : 1;

            // Play video to allow sound (some browsers require this)
            if (!newMuteState) {
                videoElement.play().catch(err => console.log('Play failed after unmute:', err));
            }
        });
    };


    // Intersection Observer for auto play/pause based on scroll
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video = entry.target;
                    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                        // Video is 50% or more visible
                        video.play().catch(err => console.log('Play prevented:', err));
                    } else {
                        // Video is out of view
                        video.pause();
                    }
                });
            },
            {
                threshold: [0, 0.5, 1], // Trigger at 0%, 50%, and 100% visibility
                rootMargin: '0px'
            }
        );

        // Observe all video elements
        const videos = document.querySelectorAll('video[data-video-index]');
        videos.forEach(video => observer.observe(video));

        return () => {
            videos.forEach(video => observer.unobserve(video));
            observer.disconnect();
        };
    }, [filteredData, activeSubTab, globalMute]);


    const fetchMasterData = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-master-data`),
                null, // No separate loading state for this individual call
                (data) => {
                    const stateData = data?.stateData || [];
                    setStates(stateData);
                }
            );
        } catch (error) {
            console.error("Error fetching master data:", error);
            setStates([]);
        }
    };

    const fetchvendordetails = async () => {
        try {
            console.log("Vendor ID:", user_id);
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-details`, {
                    id: user_id
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    setVendordetails(data);
                    setWorkinghours(data?.working_hours);
                    setWorkinghoursEnabled(data?.is_working_hours_enabled);
                    // Hide main loading IMMEDIATELY when primary data is loaded
                    setLoading(false);
                }
            );
            return true;
        } catch (error) {
            console.error("Error fetching vendor details:", error);
            // Hide loading even on error so user sees something
            setLoading(false);
            return false;
        }
    }

    const fetchVendorPostList = async () => {
        try {
            console.log("Fetching vendor posts for ID:", user_id);

            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-post-list`, {
                    login_user_id: 501,
                    user_id: user_id,
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    setVendorpostlist(data);
                }
            );
            return true;
        } catch (error) {
            console.log("Error fetching Vendor post list", error);
            return false;
        }
    };

    const fetchVendorCouponList = async (lat, lng) => {
        const payload = {
            latitude: lat,
            longitude: lng,
            // login_user_id: 501,
            user_id: user_id,
        };
        console.log("API params being sent:", payload);
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-coupon-list`, payload),
                null, // No separate loading state for this individual call
                (data) => {
                    setVendorcouponlist(data);
                    console.log(data);
                }
            );
            return true;
        } catch (error) {
            console.log("Error fetching Vendor Coupon list", error);
            return false;
        }
    }

    const fetchVendorEventList = async () => {
        if (!user_id) {
            console.log("Vendor user_id not available");
            return;
        }
        if (latitude === null || longitude === null) {
            console.log("Waiting for coordinates...");
            return;
        }
        const payload = {
            user_id: user_id,
            login_user_id: 501,
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
        };
        try {
            console.log("Fetching vendor events for ID:", user_id);
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-event-list`, payload),
                null, // No separate loading state for this individual call
                (data) => {
                    setVendoreventlist(data);
                    console.log("Vendor events response:", data);
                }
            );
            return true;
        } catch (error) {
            console.log("Error fetching Vendor Event list", error);
            return false;
        }
    }

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                // Load primary data first (vendor details) - this will hide loading when done
                if (user_id) {
                    await fetchvendordetails();
                } else {
                    setLoading(false);
                }

                // Load secondary data in parallel (don't wait for these)
                const secondaryPromises = [fetchMasterData()];
                
                if (user_id) {
                    secondaryPromises.push(fetchVendorPostList());
                }

                // Don't await - let these load in background
                Promise.all(secondaryPromises).catch(error => {
                    console.error("Error loading secondary data:", error);
                });
            } catch (error) {
                console.error("Error loading data:", error);
                setLoading(false);
            }
            // Note: setLoading(false) is now handled inside fetchvendordetails for faster display
        };

        loadData();
    }, [user_id]);


    //ACTION TYPE COLOR FOR THE ACTION TYPE
    const getActionTypeColor = (actionTypeId) => {
        switch (actionTypeId) {
            case 1: return "#1877F1";      // primaryBlue
            case 2: return "#7949FF";
            case 3: return "#0C00E8";
            case 4: return "#116C15";
            case 5: return "#04A676";
            case 6: return "#CA09FF";
            case 7: return "#FE0761";
            case 8: return "#FF17E8";
            case 9: return "#E80500";
            case 10: return "#FF7700";
            case 11: return "#03A5C9";
            case 12: return "#0A4A19";
            default: return "#1877F1";
        }
    };


    // Shimmer Component
    const ShimmerVendorDetails = () => (
        <div className="experience-main-layout">
            <LeftSection />
            <main className="experience-middle-section">
                {/* Cover and Profile Image Shimmer */}
                <div className="vendor-coverimage-and-profileimage shimmer-cover-section">
                    <div className="vendor-detail-coverimage-div">
                        <div className="vendor-detail-coverimage shimmer-box shimmer-cover-image"></div>
                    </div>
                    <div className="vendor-detail-profile-div">
                        <div className="vendor-detail-profileimage shimmer-circle shimmer-profile-image"></div>
                    </div>
                </div>

                {/* Vendor Details Shimmer */}
                <div className="vendor-detail-div shimmer-vendor-details">
                    <div className="vendor-name-button-wrapper shimmer-name-buttons">
                        <div className="shimmer-line shimmer-vendor-name"></div>
                        <div className="vendor-follow shimmer-buttons-row">
                            <div className="shimmer-box shimmer-btn-follow"></div>
                            <div className="shimmer-box shimmer-btn-message"></div>
                        </div>
                    </div>
                    <div className="shimmer-line shimmer-business-info"></div>
                    <div className="offer-section1-bottom shimmer-rating">
                        <div className="shimmer-line shimmer-rating-text"></div>
                    </div>
                    <div className="vendor-follow-mobile shimmer-mobile-buttons">
                        <div className="shimmer-box shimmer-btn-follow"></div>
                        <div className="shimmer-box shimmer-btn-message"></div>
                    </div>

                    <div className="provider-profile-body-container shimmer-body-container">
                        <div className="description-working shimmer-description">
                            <div className="vendor-description-wrapper shimmer-desc-wrapper">
                                <div className="shimmer-line shimmer-text-full"></div>
                                <div className="shimmer-line shimmer-text-partial"></div>
                                <div className="shimmer-line shimmer-text-partial-small"></div>
                            </div>
                        </div>

                        {/* Tabs Shimmer */}
                        <div className="vendor-tabs-section shimmer-tabs-section">
                            <div className="vendor-tabs shimmer-tabs">
                                <div className="shimmer-line shimmer-tab"></div>
                                <div className="shimmer-line shimmer-tab"></div>
                            </div>
                            <div className="vendor-subtabs shimmer-subtabs">
                                <div className="shimmer-line shimmer-subtab"></div>
                                <div className="shimmer-line shimmer-subtab"></div>
                                <div className="shimmer-line shimmer-subtab"></div>
                            </div>

                            {/* Content Grid Shimmer */}
                            <div className="vendor-posts-list shimmer-posts-grid">
                                {[1, 2, 3].map((item) => (
                                    <div key={item} className="feed-card shimmer-post-card">
                                        <div className="feed-header shimmer-post-header">
                                            <div className="profile-info shimmer-profile-info">
                                                <div className="shimmer-circle shimmer-avatar"></div>
                                                <div className="hotelname shimmer-hotel-name">
                                                    <div className="shimmer-line shimmer-hotel-title"></div>
                                                    <div className="shimmer-line shimmer-hotel-subtitle"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shimmer-box shimmer-post-image"></div>
                                        <div className="post-content-text shimmer-post-content">
                                            <div className="shimmer-line shimmer-text-medium"></div>
                                            <div className="shimmer-line shimmer-text-small"></div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Working Hours and Contact Shimmer */}
                        <div className="vendor-tabs-contact-row shimmer-contact-row">
                            <div className="working-calculate shimmer-working-hours">
                                <div className="shimmer-line shimmer-section-title"></div>
                                <div className="working-hours-wrapper shimmer-hours-wrapper">
                                    <div className="shimmer-line shimmer-day-time"></div>
                                    <div className="shimmer-line shimmer-day-time"></div>
                                    <div className="shimmer-line shimmer-day-time"></div>
                                </div>
                            </div>
                            <div className="vendor-contact-section shimmer-contact-section">
                                <div className="shimmer-line shimmer-section-title"></div>
                                <div className="all-contact-details-div shimmer-contact-details">
                                    <div className="contact-details-div shimmer-contact-item">
                                        <div className="shimmer-circle shimmer-contact-icon"></div>
                                        <div className="shimmer-line shimmer-contact-text"></div>
                                    </div>
                                    <div className="contact-details-div shimmer-contact-item">
                                        <div className="shimmer-circle shimmer-contact-icon"></div>
                                        <div className="shimmer-line shimmer-contact-text"></div>
                                    </div>
                                    <div className="contact-details-div shimmer-contact-item">
                                        <div className="shimmer-circle shimmer-contact-icon"></div>
                                        <div className="shimmer-line shimmer-contact-text"></div>
                                    </div>
                                    <div className="contact-details-div shimmer-contact-item">
                                        <div className="shimmer-circle shimmer-contact-icon"></div>
                                        <div className="shimmer-line shimmer-contact-text"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );

    if (loading) {
        return (
            <div>
                <Navbar />
                <ShimmerVendorDetails />
            </div>
        );
    }

    return (
        <div>
            <Navbar />

            <div className="experience-main-layout">
                <LeftSection />

                <main className="experience-middle-section">
                    <div className="vendor-coverimage-and-profileimage">
                        <div className="vendor-detail-coverimage-div">
                            <img src={vendordetails.cover_image} alt={vendordetails.name} className="vendor-detail-coverimage" />
                        </div>
                        <div className="vendor-detail-profile-div">
                            <img
                                src={vendordetails.profile_image}
                                alt={vendordetails.name}
                                className="vendor-detail-profileimage"
                            />
                        </div>
                    </div>

                    <div className="vendor-detail-div">
                        <div className="vendor-name-button-wrapper">
                            <h4 className="vendor-name">{vendordetails.name}</h4>
                            <div className="vendor-follow">
                                <button className="vendor-follow-button" onClick={() => setDownloadPopupOpen(true)}>
                                    Follow
                                </button>
                                <button className="vendor-button" onClick={() => setDownloadPopupOpen(true)}>Message</button>
                                {/* <img src={upload} alt="share" className="upload-share" onClick={() => setDownloadPopupOpen(true)} /> */}
                            </div>
                        </div>
                        <p className="business-name-and-city">{vendordetails.type_of_business} | {vendordetails.city} </p>

                        <div className="offer-section1-bottom">
                            <p className="rating-integer">5.0</p>
                            <img src={star} alt="star" className="star" />
                            <img src={star} alt="star" className="star" />
                            <img src={star} alt="star" className="star" />
                            <img src={star} alt="star" className="star" />
                            <img src={star} alt="star" className="star" />
                            <p className="review-rating">(1 Review)</p>
                        </div>

                        <div className="vendor-follow-mobile">
                            <button className="vendor-follow-button" onClick={() => setDownloadPopupOpen(true)}>
                                Follow
                            </button>
                            <button className="vendor-button" onClick={() => setDownloadPopupOpen(true)}>Message</button>
                            {/* <img src={upload} alt="share" className="upload-share" onClick={() => setDownloadPopupOpen(true)} /> */}
                        </div>

                        <div className="provider-profile-body-container">
                            <div className="description-working">
                                <div className="vendor-description-wrapper">
                                    {vendordetails.description && (() => {
                                        const descLimit = 60; // number of characters before truncation
                                        const descTruncateLength = 180;

                                        const shouldTruncate = vendordetails.description.length > descTruncateLength;

                                        return (
                                            <p className={`vendor-description ${isExpanded ? "expanded" : ""}`}>
                                                {isExpanded
                                                    ? vendordetails.description
                                                    : shouldTruncate
                                                        ? `${vendordetails.description.substring(0, descTruncateLength)}... `
                                                        : vendordetails.description
                                                }

                                                {shouldTruncate && (
                                                    <span
                                                        className="read-more-btn"
                                                        onClick={() => setIsExpanded(!isExpanded)}
                                                    >
                                                        {isExpanded ? "Less" : "More"}
                                                    </span>
                                                )}
                                            </p>
                                        );
                                    })()}
                                </div>
                                {vendordetails?.child_users?.length > 0 && (
                                    <div>
                                        <div className="child-user-header-wrapper">
                                            <h1 className="child-user-outlets">Outlets</h1>
                                            {vendordetails.child_users.length > 6 && (
                                                <p className="see-all-outlets" onClick={() => setOutletsPopupOpen(true)}>
                                                    See all
                                                </p>
                                            )}
                                        </div>

                                        <div className="child-user-grid">
                                            {vendordetails.child_users.slice(0, 6).map((item, index) => {
                                                const outletId = item.id || item.user_id;
                                                return (
                                                    <div
                                                        key={outletId || index}
                                                        className="child-user-data-div"
                                                        onClick={() => navigate(`/vendordetails/${outletId}`)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <img
                                                            src={item.profile_image}
                                                            className="child-user-profile-image"
                                                            alt={item.name}
                                                        />
                                                        <p className="child-user-name">{item.name}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}


                                {/* <div className="vendor-description-wrapper">
                               <p className={`vendor-description ${isExpanded ? "expanded" : ""}`}>
                                    {vendordetails.description}
                                </p>
                                <span
                                    className="toggle"
                                    onClick={() => setIsExpanded(!isExpanded)}
                                    style={{ color: "blue", cursor: "pointer" }}
                                >
                                    {isExpanded ? "Less" : "More"}
                                </span>
                            </div> */}

                                {/* Mobile/Tablet Contact Section - Shows above tabs when More is clicked */}
                                <div className={`vendor-contact-section-mobile ${isExpanded ? "show-contact" : ""}`}>
                                    {/* Working Hours for Mobile/Tablet */}
                                    {workinghoursEnabled === 1 && (
                                        <div className="working-calculate-mobile">
                                            <h5>Working Hours</h5>
                                            <div className="working-hours-wrapper">
                                                {/* TODAY */}
                                                <div
                                                    className="working-time-calculate-div"
                                                    onClick={() => setOpen(!open)}
                                                >
                                                    <p className="working-day">{dayNameMap[todayName]}</p>
                                                    <p className="working-time">
                                                        {todayData?.is_closed === true
                                                            ? "Closed"
                                                            : formatTimeSlots(todayData?.time_slots)}
                                                        <span className="working-time-downicon">
                                                            <img
                                                                src={downarrowicon}
                                                                className={`down-arrow-icon ${open ? "rotate-arrow" : ""}`}
                                                                alt="arrow"
                                                            />
                                                        </span>
                                                    </p>
                                                </div>

                                                {/* FULL WEEK */}
                                                <div className={`working-hours-dropdown ${open ? "open" : ""}`}>
                                                    {orderedWorkingHours.map((day, idx) => (
                                                        <div className="dropdown-day-row" key={idx}>
                                                            <p className="working-day">{dayNameMap[day.day]}</p>
                                                            <p className="working-time">
                                                                {day.is_closed === true
                                                                    ? "Closed"
                                                                    : formatTimeSlots(day.time_slots)}
                                                            </p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <h5>Contact</h5>
                                    <div className="all-contact-details-div">
                                        {vendordetails.mobile && (
                                            <div className="contact-details-div">
                                                <img src={phone} alt="phone call" />
                                                <p>
                                                    <span>+{vendordetails.dial_code}</span> {vendordetails.mobile}
                                                </p>
                                            </div>
                                        )}
                                        {vendordetails.whatsapp && (
                                            <div className="contact-details-div">
                                                <img src={whatsapp} alt="whatsapp" />
                                                <p>
                                                    <span>+{vendordetails.dial_code}</span> {vendordetails.whatsapp}
                                                </p>
                                            </div>
                                        )}
                                        {vendordetails.email && (
                                            <div className="contact-details-div">
                                                <img src={email} alt="email" />
                                                <p>{vendordetails.email}</p>
                                            </div>
                                        )}
                                        {vendordetails.website_url && (
                                            <div className="contact-details-div">
                                                <img src={www} alt="www" />
                                                <p>{vendordetails.website_url}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="vendor-tabs-section">
                                    <div className="vendor-tabs">
                                        <button
                                            className={activeTab === "Posts" ? "active" : ""}
                                            onClick={() => setActiveTab("Posts")}
                                        >
                                            Posts
                                        </button>

                                        <button
                                            className={activeTab === "Offers" ? "active" : ""}
                                            onClick={() => setActiveTab("Offers")}
                                        >
                                            Offers
                                        </button>

                                        <button
                                            className={activeTab === "Events" ? "active" : ""}
                                            onClick={() => setActiveTab("Events")}
                                        >
                                            Events
                                        </button>
                                    </div>

                                    {/* Subtabs */}
                                    {activeTab === "Posts" && (
                                        <div className="vendor-subtabs">
                                            {["All", "Images", "Videos"].map((type) => (
                                                <button
                                                    key={type}
                                                    className={activeSubTab === type ? "active" : ""}
                                                    onClick={() => setActiveSubTab(type)}
                                                >
                                                    {type}
                                                </button>
                                            ))}
                                        </div>
                                    )}

                                    {/* Content Display */}
                                    {activeTab === "Posts" && filteredData.length === 0 ? (
                                        <div className="vendor-nodata-message">
                                            <img
                                                src={nopost}
                                                className="vendor-no-data-img"
                                                alt="no posts"
                                            />
                                            <p className="vendor-no-data-p1">No posts found</p>
                                            <p className="vendor-no-data-p2">Come back later to explore</p>
                                        </div>
                                    ) : activeTab === "Offers" && (!vendorcouponlist.coupons || vendorcouponlist.coupons.length === 0) ? (
                                        <div className="vendor-nodata-message">
                                            <img
                                                src={nodata}
                                                className="vendor-no-data-img"
                                                alt="no offers"
                                            />
                                            <p className="vendor-no-data-p1">No offers found</p>
                                            <p className="vendor-no-data-p2">Come back later to explore</p>
                                        </div>
                                    ) : activeTab === "Events" && (!vendoreventlist || !Array.isArray(vendoreventlist) || vendoreventlist.length === 0) ? (
                                        <div className="vendor-nodata-message">
                                            <img
                                                src={nodata}
                                                className="vendor-no-data-img"
                                                alt="no events"
                                            />
                                            <p className="vendor-no-data-p1">No events found</p>
                                            <p className="vendor-no-data-p2">Come back later to explore</p>
                                        </div>
                                    ) : activeTab === "Offers" ? (
                                        // Display Offers
                                        <div className="vendor-offers-list">
                                            {vendorcouponlist.coupons?.map((offer) => {
                                                // Declare discountText inside map function body
                                                let discountText;

                                                switch (offer.discount_type_id) {
                                                    case 8:
                                                    case 4:
                                                        discountText = <span className="offer-tag">{offer.discount_type}</span>;
                                                        break;
                                                    case 7:
                                                        discountText = <span className="offer-tag">{offer.discount_value ? `${offer.discount_value}% OFF` : offer.discount_type}</span>;
                                                        break;
                                                    case 5:
                                                        discountText = <span className="offer-tag">Up to {offer.discount_value ? `${offer.discount_value}% OFF` : ""}</span>;
                                                        break;
                                                    case 1:
                                                        discountText = (offer.discount_value && offer.discount_price && offer.coupon_price) ? (
                                                            <>
                                                                <span className="old-price">AED {offer.coupon_price}</span>
                                                                <span className="new-price">AED {offer.discount_price}</span>
                                                                <span className="separator">|</span>
                                                                <span className="discount">{offer.discount_value}% OFF</span>
                                                            </>
                                                        ) : (
                                                            <span className="offer-tag">AED {offer.coupon_price}</span>
                                                        );
                                                        break;
                                                    case 10:
                                                        discountText = <span className="discount_type_from">From <span className="discount_coupon_price">AED {offer.coupon_price}</span></span>;
                                                        break;
                                                    default:
                                                        discountText = offer.discount_type === "Total" ? (
                                                            <span className="offer-tag">{offer.discount_value}% OFF</span>
                                                        ) : (
                                                            <span className="offer-tag">{offer.discount_type}</span>
                                                        );
                                                }

                                                return (
                                                    <Link
                                                        to={`/offers/${offer.coupon_id}/0`}
                                                        className="remove-underline"
                                                    >
                                                        <div key={offer.coupon_id} className="">
                                                            <div className="offer-image">
                                                                {offer.coupon_image && (
                                                                    <img src={offer.coupon_image} alt={offer.coupon_title} />
                                                                )}
                                                            </div>
                                                            <div className="offer-details">
                                                                <p className="offer-location">
                                                                    <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                                                                    <span>{offer.user_name}</span>
                                                                </p>

                                                                <h4>{offer.coupon_title}</h4>

                                                                <div className="kilometer-location">
                                                                    <p className="offer-distance">{offer.distance.toFixed(1)} km</p>
                                                                    <span>|</span>
                                                                    <p className="offer-location">{offer.location}</p>
                                                                </div>

                                                                {/* Discount / Price */}
                                                                <div className="offer-prices">{discountText}</div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    ) : activeTab === "Events" ? (
                                        // Display Events
                                        <div className="vendor-offers-list">
                                            {vendoreventlist && Array.isArray(vendoreventlist) && vendoreventlist.map((event) => {
                                                // Declare discountText inside map function body - same logic as offers
                                                let discountText;

                                                // Check if event has discount_type_id (same as offers)
                                                if (event.discount_type_id) {
                                                    switch (event.discount_type_id) {
                                                        case 8:
                                                        case 4:
                                                            discountText = <span className="offer-tag">{event.discount_type}</span>;
                                                            break;
                                                        case 7:
                                                            discountText = <span className="offer-tag">{event.discount_value ? `${event.discount_value}% OFF` : event.discount_type}</span>;
                                                            break;
                                                        case 5:
                                                            discountText = <span className="offer-tag">Up to {event.discount_value ? `${event.discount_value}% OFF` : ""}</span>;
                                                            break;
                                                        case 1:
                                                            discountText = (event.discount_value && event.discount_price && event.coupon_price) ? (
                                                                <>
                                                                    <span className="old-price">AED {event.coupon_price}</span>
                                                                    <span className="new-price">AED {event.discount_price}</span>
                                                                    <span className="separator">|</span>
                                                                    <span className="discount">{event.discount_value}% OFF</span>
                                                                </>
                                                            ) : (
                                                                <span className="offer-tag">AED {event.coupon_price}</span>
                                                            );
                                                            break;
                                                        case 10:
                                                            discountText = <span className="discount_type_from">From <span className="discount_coupon_price">AED {event.coupon_price}</span></span>;
                                                            break;
                                                        default:
                                                            discountText = event.discount_type === "Total" ? (
                                                                <span className="offer-tag">{event.discount_value}% OFF</span>
                                                            ) : (
                                                                <span className="offer-tag">{event.discount_type}</span>
                                                            );
                                                    }
                                                } else {
                                                    // Fallback to simple price display if no discount_type_id
                                                    if (Number(event.price_from) > 0) {
                                                        discountText = event.price_to != null ? (
                                                            <span className="discount_type_from">From <span className="discount_coupon_price">AED {event.price_from}</span></span>
                                                        ) : (
                                                            <span className="offer-tag">AED {event.price_from}</span>
                                                        );
                                                    }
                                                }

                                                return (
                                                    <Link
                                                        key={event.event_id || event.id}
                                                        to={`/eventdetails/${event.event_id || event.id}`}
                                                        className="remove-underline"
                                                    >
                                                        <div key={event.event_id || event.id} className="">
                                                            <div className="offer-image">
                                                                {event.event_image && (
                                                                    <img src={event.event_image} alt={event.title} />
                                                                )}
                                                            </div>
                                                            <div className="offer-details">
                                                                <p className="offer-location">
                                                                    <span><img src={businessicon} alt="logo" className="bussinessicon" /></span>
                                                                    <span>{event.user_name || vendordetails.name}</span>
                                                                </p>
                                                                <h4>{event.title}</h4>
                                                                {event.location_name && (
                                                                    <div className="kilometer-location">
                                                                        <p className="offer-location">{event.location_name}</p>
                                                                    </div>
                                                                )}
                                                                {/* {event.start_date && (
                                                                    <p className="offer-location" style={{ marginTop: '5px' }}>
                                                                        {event.start_date === event.end_date
                                                                            ? event.start_date
                                                                            : `${event.start_date} - ${event.end_date}`}
                                                                    </p>
                                                                )} */}
                                                                {/* Discount / Price - using same logic as offers */}
                                                                {discountText && (
                                                                    <div className="offer-prices">{discountText}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Link>
                                                );
                                            })}
                                        </div>
                                    ) : activeTab === "Posts" && activeSubTab === "Videos" ? (
                                        // Grid view for Videos subtab only
                                        <div className="video-grid">
                                            {filteredData.map((post, postIndex) => (
                                                <div 
                                                    key={post.id} 
                                                    className="video-grid-item"
                                                    onClick={() => {
                                                        navigate('/videoposts', {
                                                            state: { postData: post, postIndex: postIndex }
                                                        });
                                                        sessionStorage.setItem('videopost_navigated', 'true');
                                                        sessionStorage.setItem('fetch_all_videos', 'true');
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <video
                                                        ref={(el) => initializeVideo(el, post.video_file, `grid-${postIndex}`)}
                                                        poster={post.video_cover_picture}
                                                        muted
                                                        loop
                                                        preload="metadata"
                                                        playsInline
                                                        disablePictureInPicture

                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        // Full post view for "All" and "Images" subtabs
                                        <div className="vendor-posts-list">
                                            {filteredData.map((post, postIndex) => (
                                                <div key={post.id} className="feed-card">
                                                    <div className="feed-header">
                                                        <div className="profile-info">
                                                            <Link to={`/vendordetails/${post.user_id}`} className="remove-underline">
                                                                <img src={post.user_image} alt="feedcard1" />
                                                            </Link>
                                                            <div className="hotelname">
                                                                <Link to={`/vendordetails/${post.user_id}`} className="remove-underline">
                                                                    <h4>{post.user_name}</h4>
                                                                </Link>
                                                                <p>{post.state} | {post.following} Followers</p>
                                                            </div>
                                                        </div>
                                                        <div className="header-actions">
                                                            <p className="tag1" onClick={() => setDownloadPopupOpen(true)}>Follow</p>
                                                            <div className="more-icon-container">
                                                                <img
                                                                    src={threedot}
                                                                    alt="threedot"
                                                                    onClick={() => setDownloadPopupOpen(true)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Display video or images */}
                                                    {/* <div className="feed-image">
                                                        {post.post_images && post.post_images.length > 1 ? (
                                                            <div className="multi-post-image">
                                                                <div className="image-counter">
                                                                    {activeSlide + 1} / {post.post_images.length}
                                                                </div>
                                                                <Slider {...sliderSettings}>
                                                                    {post.post_images.map((img, idx) => (
                                                                        <div className="slide-wrapper" key={idx}>
                                                                            <img
                                                                                src={img.post_images}
                                                                                alt={`Post ${post.id} Image ${idx + 1}`}
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </Slider>
                                                            </div>
                                                        ) : post.post_images && post.post_images.length === 1 && post.post_images[0].post_images ? (
                                                            <img
                                                                src={post.post_images[0].post_images}
                                                                alt={`Post ${post.id} Image`}
                                                            />
                                                        ) : post.video_file ? (
                                                            <div className="feed-video-container">
                                                                <Link to="/videoposts">
                                                                    <video
                                                                        ref={(el) => initializeVideo(el, post.video_file, `post-${postIndex}`)}
                                                                        poster={post.video_cover_picture}
                                                                        muted
                                                                        loop
                                                                        preload="metadata"
                                                                        playsInline
                                                                    />
                                                                </Link>
                                                                <div className="normal-video-post-mute-unmute-button" onClick={toggleMute}>
                                                                    {globalMute ? (
                                                                        <img src={videomute} alt="video mute" title="Unmute" />
                                                                    ) : (
                                                                        <img src={videounmute} alt="video unmute" title="Mute" />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <img
                                                                src="https://via.placeholder.com/400x200?text=No+Media"
                                                                alt="No media available"
                                                            />
                                                        )}
                                                    </div> */}

                                                    <FeedMediaContent
                                                        post={post}
                                                        index={postIndex}
                                                        activeSlide={activeSlide}
                                                        sliderSettings={sliderSettings}
                                                        initializeVideo={initializeVideo}
                                                        globalMute={globalMute}
                                                        toggleMute={toggleMute}
                                                        videomute={videomute}
                                                        videounmute={videounmute}
                                                        getActionTypeColor={getActionTypeColor}
                                                        showFullSlider={false}  // NEW: Show only first image
                                                        isVendorDetails={true}   // NEW: Flag for vendor details page
                                                    />

                                                    <div className="post-content-text">
                                                        <div className="feed-actions">
                                                            <div className="left-icons">
                                                                <img src={hearticon} alt="heart icon" className="heart" onClick={() => setDownloadPopupOpen(true)} /><span>{post.likes > 0 ? post.likes : ''}</span>
                                                                <p className="post-vertical-line">|</p>
                                                                <img src={commenticon} alt="comment icon" className="comment" onClick={() => setDownloadPopupOpen(true)} /><span>{post.comments_count > 0 ? post.comments_count : ''}</span>
                                                                <p className="post-vertical-line">|</p>
                                                                <img src={shareicon} alt="share icon" className="shareicon" onClick={() => setDownloadPopupOpen(true)} /><span></span>
                                                            </div>
                                                            <img src={save} alt="save" id="save" onClick={() => setDownloadPopupOpen(true)} />
                                                        </div>

                                                        <div className="feed-caption">
                                                            {post.description && (() => {
                                                                // Mobile vs desktop limits (adjust as needed)
                                                                const descLimit = 60;
                                                                const descTruncateLength = 180;

                                                                const shouldTruncate = post.description.length > descTruncateLength;
                                                                const isExpanded = expand;

                                                                return (
                                                                    <p className={`feed-caption-text ${isExpanded ? "expanded" : ""}`}>
                                                                        {isExpanded
                                                                            ? post.description
                                                                            : shouldTruncate
                                                                                ? `${post.description.substring(0, descTruncateLength)}... `
                                                                                : post.description
                                                                        }

                                                                        {shouldTruncate && (
                                                                            <span
                                                                                className="feed-caption-toggle"
                                                                                onClick={() => setExpand(!expand)}
                                                                            >
                                                                                {isExpanded ? "Less" : "More"}
                                                                            </span>
                                                                        )}
                                                                    </p>
                                                                );
                                                            })()}
                                                        </div>


                                                    </div>



                                                </div>

                                            ))}
                                        </div>
                                    )}
                                </div>


                            </div>



                            <div className="vendor-tabs-contact-row">
                                {/* Left: Tabs and subtabs */}

                                {workinghoursEnabled === 1 && (
                                    <div className="working-calculate">
                                        <h5>Working Hours</h5>

                                        <div className="working-hours-wrapper">
                                            {/* TODAY */}
                                            <div
                                                className="working-time-calculate-div"
                                                onClick={() => setOpen(!open)}
                                            >
                                                <p className="working-day">{dayNameMap[todayName]}</p>
                                                <p className="working-time">
                                                    {todayData?.is_closed === true
                                                        ? "Closed"
                                                        : formatTimeSlots(todayData?.time_slots)}
                                                    <span className="working-time-downicon">
                                                        <img
                                                            src={downarrowicon}
                                                            className={`down-arrow-icon ${open ? "rotate-arrow" : ""}`}
                                                            alt="arrow"
                                                        />
                                                    </span>
                                                </p>
                                            </div>

                                            {/* FULL WEEK */}
                                            <div className={`working-hours-dropdown ${open ? "open" : ""}`}>
                                                {orderedWorkingHours.map((day, idx) => (
                                                    <div className="dropdown-day-row" key={idx}>
                                                        <p className="working-day">{dayNameMap[day.day]}</p>
                                                        <p className="working-time">
                                                            {day.is_closed === true
                                                                ? "Closed"
                                                                : formatTimeSlots(day.time_slots)}
                                                        </p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Right: Contact */}
                                <div className={`vendor-contact-section ${open ? "push-down" : ""} ${isExpanded ? "show-contact" : ""}`}>
                                    <h5 id="contact">Contact</h5>
                                    <div className="all-contact-details-div">
                                        {vendordetails.mobile && (
                                            <div className="contact-details-div">
                                                <img src={phone} alt="phone call" />
                                                <p>
                                                    <span>+{vendordetails.dial_code}</span> {vendordetails.mobile}
                                                </p>
                                            </div>
                                        )}
                                        {vendordetails.whatsapp && (
                                            <div className="contact-details-div">
                                                <img src={whatsapp} alt="whatsapp" />
                                                <p>
                                                    <span>+{vendordetails.dial_code}</span> {vendordetails.whatsapp}
                                                </p>
                                            </div>
                                        )}
                                        {vendordetails.email && (
                                            <div className="contact-details-div">
                                                <img src={email} alt="email" />
                                                <p>{vendordetails.email}</p>
                                            </div>
                                        )}
                                        {vendordetails.website_url && (
                                            <div className="contact-details-div">
                                                <img src={www} alt="www" />
                                                <p>{vendordetails.website_url}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </main>

                {/* Country pop up */}
                {/* {countrypopup && (
                    <>
                        <div className="custom-overlay" onClick={() => setCountrypopup(false)}></div>
                        <div className="custom-popup">
                            <div className="custom-popup-header">
                                <h4>Choose Your Location</h4>
                                <img src={xmark} alt="close" className="close-popup" onClick={() => setCountrypopup(false)} />
                            </div>

                            <div className="custom-popup-body">
                                <div className="state-grid">
                                    {states.filter((state) => Number(state.country_id) === 1)
                                        .map((state, index, arr) => {
                                            const isDisabled = index >= arr.length - 4;

                                            return (
                                                <div
                                                    key={state.id}
                                                    className={`state-item ${isDisabled ? "disabled" : ""}`}
                                                    onClick={() => !isDisabled && console.log("Clicked:", state.name)}
                                                >
                                                    <img
                                                        src={index < 2 ? flagicon : countryicons[index - 2]}
                                                        alt="flag"
                                                        className="flagicon-popup"
                                                    />
                                                    <p>{state.name}</p>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </>
                )} */}

                {downloadPopupOpen && (
                    <>
                        <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                        <div className="download-popup-drawer">
                            <div className="pop-up-img">
                                <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                            </div>
                            <div className="popup-header">
                                <div className="pop-up-download">
                                    <div className="hayaticon">
                                        <img src={hayatlogo} alt="Hayat In Logo" />
                                        <div className="close-btn">
                                            <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                        </div>
                                    </div>
                                    <h4 className="download-hayat">Download Our App </h4>
                                    <p id="App-description">
                                        Scan the QR code with your phone and open Hayat In instantly
                                        Your gateway to discovering the city in one tap.                                    </p>

                                    <div className="store-buttons">
                                        <div className="app_qr">
                                            <a
                                                href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={app_store} alt="App Store" />
                                            </a>

                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={play_store} alt="Google Play" />
                                            </a>
                                        </div>


                                        <div className="app_qr">
                                            <img className="qr" src={qr} alt="QR code" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {outletsPopupOpen && (
                    <>
                        <div className="overlay" onClick={() => setOutletsPopupOpen(false)}></div>
                        <div className="outlets-popup-drawer">
                            <div className="outlets-popup-header">
                                <img
                                    src={leftarrow}
                                    alt="back"
                                    className="outlets-popup-back-arrow"
                                    onClick={() => setOutletsPopupOpen(false)}
                                />
                                <h4>Outlets</h4>
                                <img
                                    src={xmark}
                                    alt="close"
                                    className="close-popup"
                                    onClick={() => setOutletsPopupOpen(false)}
                                />
                            </div>
                            <h4 className="outlets-popup-provider-name">{vendordetails.name}</h4>
                            <div className="outlets-popup-body">
                                <div className="outlets-popup-grid">
                                    {vendordetails.child_users.map((item, index) => {
                                        const outletId = item.id || item.user_id;
                                        return (
                                            <div
                                                key={outletId || index}
                                                className="outlets-popup-item"
                                                onClick={() => {
                                                    setOutletsPopupOpen(false);
                                                    navigate(`/vendordetails/${outletId}`);
                                                }}
                                            >
                                                <div className="child-user-data-div">
                                                    <img
                                                        src={item.profile_image}
                                                        className="child-user-profile-image"
                                                        alt={item.name}
                                                    />
                                                    <p className="child-user-name">{item.name}</p>
                                                </div>
                                                <Link
                                                    to={`/vendordetails/${outletId}`}
                                                    className="vendor-view-profile-btn remove-underline"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setOutletsPopupOpen(false);
                                                    }}
                                                >
                                                    View Profile
                                                </Link>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default VendorDetails